import { useState, useCallback } from "react";
import type { Player, Bracket, BracketConfig, SetupDraft } from "./types";
import { generateRound1 } from "./pairings";
import SetupScreen from "./components/SetupScreen";
import BracketView from "./components/BracketView";

import "./index.css";
import { Container, Navbar } from "react-bootstrap";

/**
 * Root application component. Manages the top-level bracket state
 * and switches between setup and bracket views.
 */
export function App() {
  const [bracket, setBracket] = useState<Bracket | null>(null);
  // Last submitted setup form, so "Back to Setup" restores the tournament
  // selection and format instead of starting from a blank screen.
  const [setupDraft, setSetupDraft] = useState<SetupDraft | null>(null);

  // Called by SetupScreen when the user clicks "Generate Bracket".
  // Creates round 1 pairings using fold pairing and initializes the bracket.
  const handleStart = useCallback(
    (players: Player[], config: BracketConfig, draft: SetupDraft) => {
      const roundOne = generateRound1(players, 3);
      setSetupDraft(draft);
      setBracket({ players, rounds: [roundOne], config });
    },
    [],
  );

  return (
    <div className="app">
      <Navbar bg="dark" variant="dark" className="mb-4 app-header">
        <Container>
          <Navbar.Brand className="wordmark">SwissMeUp</Navbar.Brand>
          <span className="wordmark-tick ms-2">Swiss Bracket Manager</span>
        </Container>
      </Navbar>
      {!bracket ? (
        <SetupScreen onStart={handleStart} initialDraft={setupDraft} />
      ) : (
        <BracketView
          bracket={bracket}
          setBracket={
            setBracket as React.Dispatch<React.SetStateAction<Bracket>>
          }
          onReset={() => setBracket(null)}
        />
      )}
    </div>
  );
}

export default App;
